import getTotalStreams from './fetchStreams';

export default {
  getTotalStreams,
};
